import React from "react";
import moment from "moment";
import { ycCompanies } from "assets/ycCompanies";
import { Link } from "react-router-dom";

const headerColumns = {
  client: {
    name: "Client",
    width: "25%",
  },
  orderId: {
    name: "ID",
    width: "5%",
  },
  orderUsername: {
    name: "Username",
    width: "15%",
  },
  roleName: {
    name: "Role",
    width: "15%",
  },
  roleLocaiton: {
    name: "Location",
    width: "15%",
  },
  orderStatus: {
    name: "Status",
    width: "5%",
  },
  dateCreated: {
    name: "Created",
    width: "10%",
  },
  lastActive: {
    name: "Last Active",
    width: "10%",
  },
};

export default function AdminOrdersPageTable() {
  return (
    <table className="w-full text-sm text-left">
      <thead className="text text-gray-800 bg-gray-59">
        <tr>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.client.width }}>
            {headerColumns.client.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderId.width }}>
            {headerColumns.orderId.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderUsername.width }}>
            {headerColumns.orderUsername.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.roleName.width }}>
            {headerColumns.roleName.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.roleLocaiton.width }}>
            {headerColumns.roleLocaiton.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderStatus.width }}>
            {headerColumns.orderStatus.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.dateCreated.width }}>
            {headerColumns.dateCreated.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.lastActive.width }}>
            {headerColumns.lastActive.name}
          </th>
        </tr>
      </thead>
      <tbody>
        {ycCompanies.map((company) => {
          function generateRandomString(len) {
            var text = "";
            var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < len; i++) text += charset.charAt(Math.floor(Math.random() * charset.length));
            return text;
          }

          const { companyName } = company;
          const orderID = generateRandomString(10);
          var formattedCompanyName = companyName.substring(0, companyName.indexOf("("));
          formattedCompanyName = formattedCompanyName.trim().replace(/\s/g, "-").toLowerCase();
          const clusterURL = `/recruiters/@randomRecruiter/clients/@${formattedCompanyName}/orders/${orderID}`;

          return (
            <tr className="cursor-pointer bg-white border-b hover:bg-gray-50 text-gray-700" key={formattedCompanyName}>
              <td className="flex items-center px-6 py-4">
                <img className="w-10 h-10 rounded-full" src={company.profileImageURL} alt={company.roleName} />
                <div className="pl-3">
                  <div className="text-base font-semibold">
                    <Link to={clusterURL}>{company.companyName}</Link>
                  </div>
                  <div className="font-normal">{company.location}</div>
                </div>
              </td>
              <td className="px-6 py-4">{Math.floor(Math.random() * 10210)}</td>
              <td className="px-6 py-4">{`@${formattedCompanyName}`}</td>
              <td className="px-6 py-4">{company.roleName}</td>
              <td className="px-6 py-4">{company.location}</td>
              <td className="px-6 py-4">
                <div className="flex items-center">
                  <div className="h-2.5 w-2.5 rounded-full bg-green-500 mr-2" /> Active
                </div>
              </td>
              <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
              <td className="px-6 py-4">{moment(new Date()).format("ddd, MMM Do")}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
